// Section Header Component
export const SectionHeader = ({ icon: Icon, title, color = "#1A3C34" }) => (
  <div className="flex items-center gap-2 mb-3">
    <Icon className="w-4 h-4" style={{ color }} />
    <h5 className="font-heading text-sm font-semibold" style={{ color }}>{title}</h5>
  </div>
);
